// extracted by mini-css-extract-plugin
export default {"lookLabel":"acM7q","lookLabelWrapper":"ckze6"};